// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1rpfe","right":"Footer_right__15OXk","buttons":"Footer_buttons__31O_N"};